import React, { useState } from "react";
import { connect } from "react-redux";
import {
  getspecificSingleProductbyname,
} from "../../../actions/singleProductAction";
import { getspecificproductvariation } from "../../../actions/variableProductAction";
import { Select, AutoComplete } from "antd";
const { Option } = Select;

const ProductName = ({
  getspecificSingleProductbyname,
  getspecificproductvariation,
  setvariations,
  setproducts,
  loading,
  setloading,
}) => {
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (value) => {
    // Ensure value is always a string
    const input = value || "";
    setSearchValue(input);

    if (input.length > 1) {
      setloading(true);
      getspecificSingleProductbyname(input).then((product) => {
        if (product && product.count > 0) {
          setproducts(product.results);
          setOptions(
            product.results.map((p) => ({
              value: p.title,
              id: p.id,
            }))
          );
        } else {
          setOptions([]);
        }
        setloading(false);
      });
    } else {
      // When input is cleared or too short, reset options
      setOptions([]);
    }
  };

  const onSelect = (value) => {
    const selectedProduct = options.find((o) => o.value === value);
    if (selectedProduct) {
      getspecificproductvariation(selectedProduct.id).then((vari) => {
        setvariations(vari);
      });
    }
  };

  return (
    <>
      <h3>Product Name</h3>
      <AutoComplete
        placeholder="Search by product name"
        style={{ width: "100%" }}
        value={searchValue}
        onChange={handleSearch}
        onSelect={onSelect}
        options={options}
        allowClear
      />
    </>
  );
};

export default connect(null, {
  getspecificSingleProductbyname,
  getspecificproductvariation,
})(ProductName);
